import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { PricingModel } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface SwitchPricingModelParams {
  pricingModel: PricingModel;
  seatCount?: number;
  fairUsageCreditLimit?: number;
  maxCredits?: number;
  billingStartDate?: string;
  billingEndDate?: string;
}

export const useSwitchPricingModel = (orgId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SwitchPricingModelParams) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.PATCH, data });
      const response = await fetch(`${APIBaseChronos}/api/org/${orgId}/pricing-model`, fetchConfig);
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || 'Failed to switch pricing model');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.OrganisationById, { orgId }]);
      queryClient.invalidateQueries([QueryEntity.OrganisationBillingPlanHistory, { orgId }]);
      toast.success('Pricing model updated successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to switch pricing model');
    },
  });
};
